import { initStore } from "./store";

const configureStore = () => {
  const actions = {

    SET_GROUPCREATORINFOLIST: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          groupCreatorInfoList: payload
        }
      };
    },
    SET_USERGROUPINVITATION: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          userGroupInvitation: payload
        }
      };
    },
    SET_GROUPINVITATIONDATA: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          groupInvitationData: payload
        }
      };
    },
    SET_GROUPPARAMFILEDATA: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          groupParamFileData: payload
        }
      };
    },
    SET_ISGROUPBACKEND: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          isGroupBackend: payload
        }
      };
    },
    SET_SELECTEDKURAFILEDATA: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          selectedKuraFileData: payload
        }
      };
    },
    SET_ISGROUPMEMBER: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          isGroupMember: payload
        }
      };
    },
    SET_SELECTEDGROUPDATA: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          selectedGroupData: payload
        }
      };
    },
    // SET_JOINGROUPID: (state, payload) => {
    //   return {
    //     // ...state,
    //     groupStore: {
    //       ...state.groupStore,
    //       joinGroupId: payload
    //     }
    //   };
    // },
    // SET_GROUPTALKINPUTLIST: (state, payload) => {
    //   return {
    //     // ...state,
    //     groupStore: {
    //       ...state.groupStore,
    //       groupTalkInputList: payload
    //     }
    //   };
    // },
    SET_GROUPROOMINUSERSDATA: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          groupRoomInUsersData: payload,
        }
      };
    },
    SET_USERSOCKETID: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          userSocketId: payload,
        }
      };
    },
    SET_SOCKETSTATE: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          socketState: payload,
        }
      };
    },
    SET_GROUPLIST: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          groupList: payload,
        }
      };
    },
    SET_GROUPNOAUTHUSERID: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          groupNoAuthUserId: payload,
        }
      };
    },
    SET_GROUPTEXTINPUT: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          groupTextInput: payload,
        }
      };
    },
    SET_GROUPTEXTITEMREF: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          groupTextItemRef: payload,
        }
      };
    },
    SET_USERGETGROUPKURAFILEDATALIST: (state, payload) => {
      return {
        // ...state,
        groupStore: {
          ...state.groupStore,
          userGetGroupKuraFileDataList: payload,
        }
      };
    },
  };

  initStore(actions, {
    groupStore: {
      groupCreatorInfoList: [],
      userGroupInvitation: null,
      groupInvitationData: null,
      groupParamFileData: null,
      isGroupBackend: false,
      selectedKuraFileData: null,
      isGroupMember: false,
      selectedGroupData: null,
      groupRoomInUsersData: null,
      userSocketId: '',
      socketState: null,
      groupList: [],
      groupNoAuthUserId: '',
      groupTextInput: '',
      groupTextItemRef: null,
      userGetGroupKuraFileDataList: [],
    }
  });
};

export default configureStore;
